// extracted by mini-css-extract-plugin
export default {"title-user":"MyCourseVideo_title-user__gq2hw"};